import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/tmp/builds/n85FxqY8/0/kreezus/calendar/calendar-api/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AppointmentWidget, MomentUtils, isProPlan } from '@yalendar/shared/ui-core';
import { HeadSeo } from '../../components/Seo';
import { AppointmentStatus } from '@prisma/client';
import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';
import useBookingAppointment from '../../hooks/useBookingAppointment';
import { useTranslation } from 'react-i18next';
import InactifCalendarPage from '../../components/InactifCalendar';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import { useTracking } from '../../contexts/trackers';
import { UserContext } from '../../hooks/useAuth';
import { stringify } from 'querystring';
dayjs.extend(utc);
dayjs.extend(customParseFormat);
var CURRENT_DATE_FORMAT = 'YYYY-MM-DDZZ';
export var __N_SSP = true;
var SLOT_HOUR_FORMAT = 'HH:mm';
export function PublicCalendar(_ref) {
  var _organization$showYal;

  var organization = _ref.organization,
      calendar = _ref.calendar,
      appointementToReschedule = _ref.appointementToReschedule,
      timeSlots = _ref.timeSlots,
      browserConfigProps = _ref.browserConfigProps,
      isAllowedToCollectPayment = _ref.isAllowedToCollectPayment;
  var router = useRouter();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useContext = useContext(UserContext),
      user = _useContext.user,
      isLoading = _useContext.isLoading;

  var _useState = useState(true),
      isTimeSlotsLoading = _useState[0],
      setTimeSlotsLoading = _useState[1];

  var _useTracking = useTracking(),
      logEvent = _useTracking.logEvent;

  var _useState2 = useState(calendar),
      currentCalendar = _useState2[0],
      setCurrentCaledar = _useState2[1];

  var _useState3 = useState({
    periodStart: dayjs(dayjs()).startOf('month').format(),
    slots: []
  }),
      slots = _useState3[0],
      setSlots = _useState3[1];

  var isConnectedUserAssignedToCurrentCalendar = function isConnectedUserAssignedToCurrentCalendar() {
    return user && calendar.calendarAssignments.length > 0 ? calendar.calendarAssignments.find(function (calAssignment) {
      return calAssignment.userId === user.id;
    }) != undefined : false;
  };

  var _useBookingAppointmen = useBookingAppointment(),
      createAppointment = _useBookingAppointmen.createAppointment,
      updateAppointment = _useBookingAppointmen.updateAppointment,
      error = _useBookingAppointmen.error;

  var _useState4 = useState(Intl.DateTimeFormat().resolvedOptions().timeZone),
      guestTimezone = _useState4[0],
      setGuestTimezone = _useState4[1];

  var _useState5 = useState(appointementToReschedule),
      appointment = _useState5[0],
      setAppointment = _useState5[1]; // add a query (back) param on url


  var currentMonth = useMemo(function () {
    var monthString = typeof router.query.month === 'string' ? router.query.month : null;

    if (monthString) {
      return monthString;
    }

    return null;
  }, [router.query.month]);
  var currentDate = useMemo(function () {
    var dateString = typeof router.query.date === 'string' ? router.query.date : null;

    if (dateString) {
      // todo some extra validation maybe.
      var utcOffsetAsDate = dayjs(dateString.substr(11, 14), 'Hmm');
      var utcOffset = parseInt(dateString.substr(10, 1) + (utcOffsetAsDate.hour() * 60 + utcOffsetAsDate.minute()));
      var date = dayjs(dateString.substr(0, 10)).utcOffset(utcOffset, true);
      return date.isValid() ? date : null;
    }

    return null;
  }, [router.query.date]);
  var initialSlots = useMemo(function () {
    return timeSlots;
  }, [timeSlots]);

  var inserTimezone = function inserTimezone(time, minutes) {
    var timeHours = parseInt(time.split(':')[0]);
    var timeMinutes = parseInt(time.split(':')[1]);
    return timeHours * 60 + timeMinutes + minutes;
  };

  var convertSlotByTimezone = useCallback(function (givenTimeslots) {
    var timezoneOffset = dayjs().tz(guestTimezone).utcOffset() - dayjs().tz(calendar.timezone).utcOffset();
    if (timezoneOffset === 0) return timeSlots;
    var results = timeSlots.length && timeSlots.map(function (el) {
      return _objectSpread(_objectSpread({}, el), {}, {
        slots: []
      });
    }) || [];
    timeSlots === null || timeSlots === void 0 ? void 0 : timeSlots.forEach(function (timeSlot) {
      var _timeSlot$slots;

      (_timeSlot$slots = timeSlot.slots) === null || _timeSlot$slots === void 0 ? void 0 : _timeSlot$slots.forEach(function (interval) {
        var startInterval = inserTimezone(interval.startTime, timezoneOffset);
        var endInterval = inserTimezone(interval.endTime, timezoneOffset);
        var startTime;
        var endTime;

        if (startInterval >= 0 && endInterval >= 0) {
          startTime = dayjs(timeSlot.dateOfDay).startOf('day').add(startInterval, 'minutes');
          endTime = dayjs(timeSlot.dateOfDay).startOf('day').add(endInterval, 'minutes');
        } else if (startInterval <= 0 && endInterval <= 0) {
          startTime = dayjs(timeSlot.dateOfDay).startOf('day').subtract(-1 * startInterval, 'minutes');
          endTime = dayjs(timeSlot.dateOfDay).startOf('day').subtract(-1 * endInterval, 'minutes');
        }

        if (startTime && endTime) {
          results.forEach(function (result, index) {
            var _startTime, _endTime;

            result.dateOfDay === ((_startTime = startTime) === null || _startTime === void 0 ? void 0 : _startTime.format('YYYY-MM-DD')) && ((_endTime = endTime) === null || _endTime === void 0 ? void 0 : _endTime.format('YYYY-MM-DD')) && (results[index].slots = [].concat(_toConsumableArray(results[index].slots), [{
              status: interval.status,
              startTime: startTime.format(SLOT_HOUR_FORMAT),
              endTime: endTime.format(SLOT_HOUR_FORMAT),
              remainingSpot: interval.remainingSpot,
              conflicts: interval.conflicts
            }]));
          });
        }
      });
    });
    return results;
  }, [guestTimezone, timeSlots]);
  var selectedSlotFromUrl = useMemo(function () {
    var convertTimeSlotToGuestTimezone = convertSlotByTimezone(timeSlots);

    var slotToSlotEntity = function slotToSlotEntity(slotInString) {
      var foundSlots = convertTimeSlotToGuestTimezone.map(function (dayWithSlots) {
        return dayjs(dayWithSlots.dateOfDay, 'YYYY-MM-DD').isSame(currentDate, 'day') ? dayWithSlots.slots.find(function (slot) {
          return slot.startTime === slotInString;
        }) : undefined;
      }).filter(function (result) {
        return result !== undefined;
      });
      return foundSlots.length > 0 ? foundSlots[0] : undefined;
    };

    var canFormatSlotEntityAndSlotExist = function canFormatSlotEntityAndSlotExist(slotInString) {
      return dayjs(slotInString, SLOT_HOUR_FORMAT).isValid() && convertTimeSlotToGuestTimezone.filter(function (dayWithSlots) {
        return dayjs(dayWithSlots.dateOfDay, 'YYYY-MM-DD').isSame(currentDate, 'day') && dayWithSlots.slots.filter(function (slot) {
          return slot.startTime === slotInString;
        }).length > 0;
      }).length > 0;
    };

    var guestSlotStartTimeInGuestTZ = router.query.slot ? router.query.slot : undefined;
    return guestSlotStartTimeInGuestTZ ? canFormatSlotEntityAndSlotExist(guestSlotStartTimeInGuestTZ) ? slotToSlotEntity(guestSlotStartTimeInGuestTZ) : undefined : undefined;
  }, [convertSlotByTimezone, currentDate, router.query.slot, timeSlots]);

  var filterPassTimeSlots = function filterPassTimeSlots(slots, userTimezone, guestTimezone) {
    var timezoneOffset = dayjs().tz(userTimezone).utcOffset() - dayjs().tz(guestTimezone).utcOffset();
    slots.forEach(function (timeInterval) {
      var slotsFiltered = [];
      var GMT0 = 'Etc/GMT';
      if (timeInterval.slots.length === 0) slotsFiltered.push.apply(slotsFiltered, _toConsumableArray(timeInterval.slots));
      timeInterval.slots.forEach(function (slot) {
        var startTime = MomentUtils.setTime(timeInterval.dateOfDay, slot.startTime);
        var newDate = timezoneOffset < 0 ? MomentUtils.substract(dayjs().tz(GMT0).toDate(), timezoneOffset, 'minute').toDate() : MomentUtils.add(dayjs().tz(GMT0).toDate(), timezoneOffset, 'minute').toDate();

        if (!MomentUtils.isBefore(startTime, newDate)) {
          slotsFiltered.push(slot);
        }
      });
      timeInterval.slots = slotsFiltered;
    });
    return slots;
  };

  var convertDateByTimezone = function convertDateByTimezone(date, userTimezone, guestTimezone) {
    var timezoneOffset = dayjs().tz(userTimezone).utcOffset() - dayjs().tz(guestTimezone).utcOffset();
    return timezoneOffset === 0 ? date : timezoneOffset > 0 ? dayjs(date).add(timezoneOffset, 'minutes').toDate() : dayjs(date).subtract(-1 * timezoneOffset, 'minutes').toDate();
  };

  var onCancelFromGuestInfo = function onCancelFromGuestInfo() {
    var _router$query = router.query,
        slot = _router$query.slot,
        restQuery = _objectWithoutProperties(_router$query, ["slot"]);

    currentDate && router.push({
      query: _objectSpread(_objectSpread({}, restQuery), {}, {
        date: currentDate.format(CURRENT_DATE_FORMAT)
      })
    }, undefined, {
      shallow: true
    });
  };

  var onTimeSlotSelected = function onTimeSlotSelected(slot) {
    currentDate && router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        date: currentDate.format(CURRENT_DATE_FORMAT),
        slot: slot.startTime
      })
    }, undefined, {
      shallow: true
    });
  };

  var createPaymentLink = function createPaymentLink(opts) {
    var paymentUid = opts.paymentUid,
        name = opts.name,
        date = opts.date,
        _opts$absolute = opts.absolute,
        absolute = _opts$absolute === void 0 ? true : _opts$absolute;
    var link = '';
    if (absolute) link = browserConfigProps.apiBaseURL;
    var query = stringify({
      date: date,
      name: name
    });
    return link + "/payment/".concat(paymentUid, "?").concat(query);
  };

  var bookAppointment = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(calendarId, data) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", toast.promise(createAppointment(browserConfigProps.apiBaseURL, calendarId, _objectSpread(_objectSpread({}, data), {}, {
                startTime: data.startTime,
                endTime: data.endTime,
                status: AppointmentStatus.ACCEPTED
              })).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appointment) {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!appointment.paymentUid) {
                            _context.next = 5;
                            break;
                          }

                          _context.next = 3;
                          return router.push(createPaymentLink({
                            paymentUid: appointment.paymentUid,
                            date: appointment.startTime.toString(),
                            name: appointment.guestName,
                            absolute: false
                          }));

                        case 3:
                          _context.next = 7;
                          break;

                        case 5:
                          logEvent({
                            category: 'Booking',
                            action: 'Booked appointment',
                            label: "".concat(appointment.guestName, " and ").concat(appointment.userId)
                          });
                          return _context.abrupt("return", router.push("/success/".concat(appointment.id)).then(function () {
                            return void 0;
                          }));

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()), {
                error: function error(err) {
                  return err.message;
                },
                loading: t('bookingSuccess.bookingToastLoading'),
                success: t('bookingSuccess.bookingToastSuccess')
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function bookAppointment(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var rescheduleAppointment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(appointmentId, data) {
      var _calendar$id;

      var updateAppointmentPromise;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              updateAppointmentPromise = updateAppointment(browserConfigProps.apiBaseURL, (_calendar$id = calendar === null || calendar === void 0 ? void 0 : calendar.id) !== null && _calendar$id !== void 0 ? _calendar$id : '', appointmentId, _objectSpread(_objectSpread({}, data), {}, {
                startTime: data.startTime,
                endTime: data.endTime,
                status: AppointmentStatus.ACCEPTED,
                rescheduleReason: data.rescheduleReason
              }), guestTimezone);
              toast.promise(updateAppointmentPromise, {
                loading: t('appointmentViewerWidget.rescheduleToast'),
                success: /*#__PURE__*/_jsx("b", {
                  children: t('appointmentViewerWidget.rescheduleToastSuccess')
                }),
                error: /*#__PURE__*/_jsx("b", {
                  children: t('appointmentViewerWidget.rescheduleToastError')
                })
              }).then(function () {
                router.replace('/');
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function rescheduleAppointment(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var changeGuestTimezone = function changeGuestTimezone(tz) {
    var timezone = typeof tz === 'string' ? tz : tz.value;
    setGuestTimezone(timezone);

    if (currentDate) {
      changeTheCurrentDate(currentDate.tz(timezone, true));
    }
  };

  var changeTheCurrentDate = function changeTheCurrentDate(date, timezone) {
    var newDateToGo = date.format(CURRENT_DATE_FORMAT);
    router.push({
      query: _objectSpread(_objectSpread({}, router.query), {}, {
        date: newDateToGo
      })
    }, undefined, {
      shallow: true
    });
  };

  var changeTheCurrentMonth = function changeTheCurrentMonth(monthFormat, monthNumber) {
    var _router$query2 = router.query,
        date = _router$query2.date,
        calendarTypeSlug = _router$query2.calendarTypeSlug,
        organizationSlug = _router$query2.organizationSlug,
        keptQuery = _objectWithoutProperties(_router$query2, ["date", "calendarTypeSlug", "organizationSlug"]);

    router.push({
      pathname: "/".concat(organization.slug, "/").concat(currentCalendar.slug),
      query: _objectSpread(_objectSpread({}, keptQuery), {
        month: "".concat(dayjs(monthFormat).format('YYYY-MM'))
      })
    });
  };

  var convertAndFilterSlotsAccordingToTimezones = useCallback(function (retrievedTimeslots) {
    retrievedTimeslots = convertSlotByTimezone(retrievedTimeslots || initialSlots);
    var filteredTimeslots = filterPassTimeSlots(retrievedTimeslots || initialSlots, currentCalendar.timezone, guestTimezone);
    /* filteredTimeslots.length - 2 mean When the time zone is different from GMT, the first value in the table coincides with the previous month and this distorts the calculations. */

    var index = Math.floor(filteredTimeslots.length / 2);
    var periodStart = filteredTimeslots.length > 0 ? dayjs(filteredTimeslots[index].dateOfDay).startOf('month').format() : dayjs(dayjs(currentMonth)).startOf('month').format();
    setSlots({
      periodStart: periodStart,
      slots: filteredTimeslots
    });
  }, [convertSlotByTimezone, currentCalendar.timezone, currentMonth, guestTimezone, initialSlots]);
  useEffect(function () {
    router.isReady && setTimeSlotsLoading(false); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(function () {
    convertAndFilterSlotsAccordingToTimezones(initialSlots);
  }, [convertAndFilterSlotsAccordingToTimezones, initialSlots]);

  var goToBack = function goToBack() {
    return router.push("/".concat(organization.slug));
  };

  var _useBookingAppointmen2 = useBookingAppointment(),
      onFileUploadBucket = _useBookingAppointmen2.onFileUploadBucket;

  var _onFileUpload = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(calendarId, file) {
      var fileUrl;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return onFileUploadBucket(browserConfigProps.apiBaseURL, calendarId, file);

            case 2:
              fileUrl = _context4.sent;
              return _context4.abrupt("return", fileUrl);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function onFileUpload(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(HeadSeo, {
      title: "".concat(t('common.seoAppointment'), " ").concat(currentCalendar === null || currentCalendar === void 0 ? void 0 : currentCalendar.name, " | ").concat(currentCalendar.group.name),
      description: "".concat((currentCalendar === null || currentCalendar === void 0 ? void 0 : currentCalendar.description) || "".concat(t('common.seoAppointment'), " ").concat(currentCalendar === null || currentCalendar === void 0 ? void 0 : currentCalendar.name, " | ").concat(currentCalendar.group.name)),
      name: "".concat(t('common.seoAppointment'), " **").concat(currentCalendar.name, "** - ").concat(currentCalendar.group.name),
      avatar: organization.profilePictureUrl
    }), currentCalendar && currentCalendar.active ? /*#__PURE__*/_jsx(AppointmentWidget // Display configuration paramètres
    , {
      isEmbeded: browserConfigProps.isEmbeded,
      isLoadingSlots: isTimeSlotsLoading,
      shouldHideCalendarImage: router.query.hideimage !== undefined && router.query.hideimage === '1',
      isDiagnosticMode: router.query.diagnostics !== undefined && router.query.diagnostics === '1',
      hideInfosColumn: router.query.hideinfos !== undefined && router.query.hideinfos === '1',
      previewMode: router.query.preview !== undefined && router.query.preview === '1',
      showTroubleShotButton: isConnectedUserAssignedToCurrentCalendar(),
      onTroubleShotClicked: function onTroubleShotClicked(diagnosticActive) {
        var _router$query3 = router.query,
            diagnostics = _router$query3.diagnostics,
            keptQuery = _objectWithoutProperties(_router$query3, ["diagnostics"]);

        currentDate && router.push({
          query: _objectSpread(_objectSpread({}, keptQuery), {}, {
            date: currentDate.format(CURRENT_DATE_FORMAT)
          }, diagnosticActive && {
            diagnostics: '1'
          })
        }, undefined, {
          shallow: true
        });
      },
      showRemainingSpot: router.query.remainingspot ? router.query.remainingspot === '1' : false,
      isGoBack: router.query.back === '1' ? true : false // Date and calendar Type configuration
      ,
      goBack: goToBack,
      selectedTime: selectedSlotFromUrl,
      calendar: currentCalendar,
      timeSlots: slots.slots,
      initialPeriodStart: currentMonth ? dayjs(currentMonth, 'YYYY-MM').startOf('month').format() : slots.periodStart,
      selectedDate: currentDate || undefined,
      onTimeSlotSelected: onTimeSlotSelected,
      bookAppointment: bookAppointment,
      appointmentToUpdate: appointment || undefined,
      rescheduleAppointment: rescheduleAppointment,
      changeGuestTimezone: changeGuestTimezone,
      guestTimezone: guestTimezone,
      onSelectedDateChanged: function onSelectedDateChanged(date) {
        return changeTheCurrentDate(date.tz(guestTimezone, true));
      },
      onSelectedMonthChanged: changeTheCurrentMonth,
      onCancelFromGuestInfo: onCancelFromGuestInfo,
      calendarLocations: currentCalendar.locations,
      showRibbon: (_organization$showYal = organization.showYalendarBranding) !== null && _organization$showYal !== void 0 ? _organization$showYal : !isProPlan(currentCalendar.group),
      calendarCustomInputs: currentCalendar.customInputs // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ,
      onFileUpload: function onFileUpload(file) {
        return _onFileUpload(currentCalendar.id, file);
      },
      isAllowedToCollectPayment: isAllowedToCollectPayment
    }) : /*#__PURE__*/_jsx(InactifCalendarPage, {})]
  });
}
export default PublicCalendar;